import React from 'react';
import {bindActionCreators} from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../redux/actions';
import ReportNew from './ReportNew';
import ReportDrafts from './ReportDrafts';
import ReportHistory from './ReportHistory';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import HistoryIcon from '@mui/icons-material/History';
import '../styles/report.scss';

class ReportDash extends React.Component {
  constructor() {
    super();

    this.state = {
      activeTab: 'new',
    }
  }

  componentDidMount() {
    this.props.showNav(true);
    this.props.fetchAccounts(this.props.authToken);
    this.props.fetchReportDrafts(null, this.props.authToken);
  }

  setActiveTab(tab) {
    this.setState({ activeTab: tab });
    if (tab === 'drafts') {
      this.props.fetchReportDrafts(null, this.props.authToken);
    }
  }

  // Admins can list every employee's drafts, so the badge counts only their
  // own. Operators share drafts with their account and see them all.
  ownDraftCount() {
    const drafts = this.props.drafts || [];
    return this.props.user?.operator ? drafts.length : drafts.filter((d) => d.mine !== false).length;
  }

  render() {
    return (
      <div className="report-dashboard">
        <div className="dashboard-header">
          <div className="header-content">
            <h1>Reports</h1>
            <div className="tab-nav">
              <button 
                className={`nav-tab ${this.state.activeTab === 'new' ? 'active' : ''}`}
                onClick={() => this.setActiveTab('new')}
              >
                <AddIcon />
                <span>New</span>
              </button>
              <button 
                className={`nav-tab ${this.state.activeTab === 'drafts' ? 'active' : ''}`}
                onClick={() => this.setActiveTab('drafts')}
              >
                <EditIcon />
                <span>Drafts</span>
                {this.ownDraftCount() > 0 && (
                  <span className="badge">{this.ownDraftCount()}</span>
                )}
              </button>
              <button 
                className={`nav-tab ${this.state.activeTab === 'history' ? 'active' : ''}`}
                onClick={() => this.setActiveTab('history')}
              >
                <HistoryIcon />
                <span>History</span>
              </button>
            </div>
          </div>
        </div>

        <div className="dashboard-main">
          {this.state.activeTab === 'new' && (
            <div className="dashboard-section new-report-section">
              <ReportNew />
            </div>
          )}
          {this.state.activeTab === 'drafts' && (
            <div className="dashboard-section drafts-section">
              <ReportDrafts />
            </div>
          )}
          {this.state.activeTab === 'history' && (
            <div className="dashboard-section history-section">
              <ReportHistory />
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    report: state.report,
    authToken: state.authToken,
    drafts: state.drafts,
    accounts: state.accounts,
    history: state.reportHistory,
    user: state.user
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportDash);
